import React, { useState } from "react";
import { PiMagnifyingGlass } from "react-icons/pi";
import { TbList } from "react-icons/tb";
import ErrorMessage from "../../Components/ErrorMessage";
import Spinner from "../../Components/Spinner";
import { MdOutlineChecklist } from "react-icons/md";
import { useLanguage } from "../../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const WebsiteSource = ({
    account_id,
    org_id,
    context_id,
    fetchRecords,
    closeModal,
    handleBack
}) => {
    const { t } = useLanguage()
    const [loading, setLoading] = useState(false);
    const [loadingExtract, setLoadingExtract] = useState(false);
    const [errorMessage, setErrorMessage] = useState({
        message: "",
        display: false,
    });

    const [urls, setUrls] = useState([]);
    const [selectedUrls, setSelectedUrls] = useState([]);
    const [websiteURL, setWebsiteUrl] = useState("");

    const scanUrl = async () => {
        if (!websiteURL.trim()) {
            setErrorMessage({
                message: "Please enter a website URL",
                display: true,
            });
            return;
        }

        // const urlRegex =
        //     /^(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?:[/?#][^\s]*)?$/;

        // if (!urlRegex.test(websiteURL.trim())) {
        //     setErrorMessage({
        //         message: "Please enter a valid website URL.",
        //         display: true,
        //     });
        //     return;
        // }

        setLoading(true);
        setErrorMessage({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/website_url_scan`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    website_url: websiteURL.trim(),
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            if (data.message === "OK") {
                setUrls(data.urls || []);
                setSelectedUrls([]);
            }
        } catch (error) {
            setErrorMessage({
                message: error.message || "Server error",
                display: true,
            });
        } finally {
            setLoading(false);
        }
    };

    const handleUrlSelection = (url) => {
        setSelectedUrls((prevSelected) => {
            if (prevSelected.includes(url)) {
                return prevSelected.filter((item) => item !== url);
            }

            return [...prevSelected, url];
        });
    };

    const handleSelectAll = () => {
        if (selectedUrls.length === urls.length) {
            setSelectedUrls([]);
        } else {
            setSelectedUrls([...urls]);
        }
    };

    const extractContent = async () => {
        if (selectedUrls.length === 0) {
            setErrorMessage({
                message: t.context.please_select_url,
                display: true,
            });
            return;
        }

        setLoadingExtract(true);
        setErrorMessage({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/crawl_urls`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    org_id,
                    context_id,
                    selected_urls: selectedUrls
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            if (data.message === "OK") {
                closeModal()
                fetchRecords()
            }
        } catch (error) {
            setErrorMessage({
                message: error.message || "Server error",
                display: true,
            });
        } finally {
            setLoadingExtract(false);
        }
    };

    return (
        <div className="source_cont">
            <p className="source_cont_website_title">
                {t.context.add_url_title}
            </p>

            <p className="source_cont_website_subtitle">
                {t.context.add_utl_description}
            </p>

            <div className="source_website_input_cont">
                <div className="source_website_input">
                    <p className="source_website_input_prefix">
                        https://
                    </p>
                    <input
                        className="source_website_main_inputs"
                        type="text"
                        value={websiteURL}
                        onChange={(e) => {
                            setWebsiteUrl(e.target.value);
                            setUrls([]);
                            setSelectedUrls([]);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && !loading) {
                                scanUrl();
                            }
                        }}
                        placeholder="example.com"
                    />
                </div>

                <button
                    className="source_website_btn"
                    onClick={scanUrl}
                    disabled={loading}
                >
                    {loading ? <Spinner loading={loading} /> : <PiMagnifyingGlass />}
                </button>
            </div>

            <div className="source_website_pages_list">
                {urls.length === 0 ? (
                    <div className="source_website_pages_list_empty">
                        <p>
                            <i><TbList /></i> {t.context.urls_appear_title}</p>
                    </div>
                ) : (
                    <div className="source_website_pages_list_urls fade-in">
                        <div className="source_website_pages_list_header">
                            <button
                                className="source_website_pages_list_header_btn"
                                onClick={handleSelectAll}
                            >
                                <MdOutlineChecklist /> {selectedUrls.length === urls.length ? t.context.deselect_all : t.context.select_all}
                            </button>
                            <p>{urls.length} {urls.length > 1 ? "URLs" : "URL"}</p>
                        </div>
                        <div className="source_website_pages_list_urls_inner">
                            {loading}
                            {urls.map((url) => (
                                <div
                                    key={url}
                                    className={`source_website_page_item ${selectedUrls.includes(url)
                                        ? "source_website_page_item_selected"
                                        : ""
                                        }`}
                                    onClick={() => handleUrlSelection(url)}
                                >
                                    <p className="source_website_page_item_url">
                                        {url}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
            {selectedUrls.length > 0 && (
                <p className="warning_source_message">{t.context.url_warning}</p>
            )}

            {errorMessage.display && (
                <ErrorMessage err={errorMessage} />
            )}

            {selectedUrls.length > 0 && (
                <button className="source_run_btn fade-in" onClick={extractContent}>
                    {loadingExtract ? <Spinner loading={loadingExtract} /> : t.context.start_web_extraction}
                </button>
            )}
        </div>
    );
};

export default WebsiteSource;
